import React, { useEffect, useState } from "react";
import { Row, Col, Typography, Tag, Menu, Dropdown, Icon, Input, Button, Modal, Select, DatePicker, message, Table, Avatar } from "antd";
import "./SharePoint.scss";
import CoinLogo from "./images/Coin.png";
import moment from "moment";

import { ReactComponent as SharePointsLogo } from "./images/SharePointsLogo.svg";

import { ReactComponent as DubaiLogo } from "./images/DubaiLogo.svg";
import Loader from "../../components/Loader/Loader";
import RecentTransactions from "./RecentTransactions";
import { fetchSharePointsAdminDataApi, fetchSharePointsAdminRecentTxnsApi, updateFeatureListApi } from "utils/apiService";
import LeaderBoard from "./LeaderBoard";
import BarPlots from "./BarPlots";

const { Text } = Typography;

const SharePointsAnalytics = () => {
	const Today = new moment();
	Today.format("YYYY-MM-DD");
	const [loading, setLoading] = useState(true);
	const [sharePointAnalytics, setSharePointAnalytics] = useState({});
	const [settingModal, setSettingModal] = useState(false);
	const [settings, setSettings] = useState({
		data1: "",
		data2: "",
	});
	const [range, setRange] = useState({
		start_date: Today,
		end_date: Today,
	});
	const formatDate = (date, from, to) => {
		var newDate = date ? new moment(date, from) : new moment();

		return newDate.format(to);
	};
	const loadData = () => {
		fetchSharePointsAdminDataApi({
			requestData: {
				start_date: formatDate(range.start_date, "YYYY-MM-DD", "DD-MM-YYYY"),
				end_date: formatDate(range.end_date, "YYYY-MM-DD", "DD-MM-YYYY"),
			},
			res200Callback: async (res) => {
				setSharePointAnalytics(res.data);
				loading && setLoading(false);
			},
			resErrorCallback: (err) => {
				message.error(JSON.stringify(err.data));
			},
		});
	};

	useEffect(() => {
		loadData();
	}, [range]);

	useEffect(() => {
		!settingModal && setSettings({
			data1: "",
			data2: "",
		});
	}, [settingModal]);

	return (
		<>
			{loading && (
				<div
					style={{
						minHeight: "100vh",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						backgroundColor: "#FAFAFA",
					}}>
					<Loader />
				</div>
			)}
			{!loading && (
				<Row
					style={{
						width: "100%",
						padding: "40px 25px 0",
						margin: "60px auto 20px",
						backgroundColor: "#FAFAFA",
					}}
					gutter={[12, 48]}>
					<Row
						style={{
							display: "flex",

							// justifyContent: "space-between",
						}}>
						<Text
							style={{
								width: "75%",
								fontStyle: "normal",
								fontWeight: "bold",
								fontSize: "24px",
								marginLeft: "10px",
								lineHeight: "40px",
								color: "#181818",
							}}>
							Share Points
						</Text>
						{/* <Row
							style={{
								display: "flex",
								// width: "40%",
								justifyContent: "space-between",
							}}> */}
							<DatePicker.RangePicker
								style={{ width: "281px", background: "#FFFFFF", border: "1px solid #E6E6E6", borderRadius: "4px" }}
								format={"DD MMM YYYY"}
								onChange={(e) => {
									setRange({
										start_date: e[0] ? e[0].format("YYYY-MM-DD") : "2021-11-09",
										end_date: e[1] ? e[1].format("YYYY-MM-DD") : "",
									});
								}}
							/>
							{/* <Button
								type="primary"
								style={{
									width: "115px",
									height: "40px",
									background: "#FFFFFF",
									border: "1px solid #D1D1D1",
									boxSizing: "border-box",
									borderRadius: "4px",
									marginLeft: "8px",
									display: "flex",
									alignItems: "center",
									color: "#181818",
									padding: "8px 16px",
								}}
								onClick={() => {
									setSettingModal(true);
								}}>
								<Icon type="setting" theme="outlined" />

								<Text
									style={{
										fontStyle: "normal",
										fontWeight: "normal",
										fontSize: "16px",
										lineHeight: "24px",
										color: "#181818",
									}}>
									Settings
								</Text>
							</Button> */}
						{/* </Row> */}
					</Row>
					<Row
						style={{
							display: "flex",
							justifyContent: "space-around",
						}}>
						<div
							style={{
								width: "70%",
							}}>
							<Row
								style={{
									marginTop: "32px",
								}}>
								<Row
									style={{
										width: "100%",
										height: "180px ",
										background: "#EAF4EC",
										borderRadius: "8px",
										// display: "flex",
										// justifyContent: "space-between",
									}}>
									<Col span={12}>
										<Row style={{ margin: "24px" }}>
											<div
												style={{
													display: "flex",
												}}>
												<Avatar style={{ width: "50px", height: "50px" }} src={CoinLogo} />
												<div
													style={{
														display: "flex",
														marginLeft: "12px",
														flexDirection: "column",
													}}>
													<Text
														style={{
															fontStyle: "normal",
															fontWeight: "700",
															fontSize: "20px",
															lineHeight: "32px",
															color: "#005F0E",
															whiteSpace: "nowrap",
														}}>
														Points Shared Status
													</Text>
													<Text
														style={{
															fontStyle: "normal",
															fontWeight: "500",
															fontSize: "12px",
															lineHeight: "18px",
															color: "#005F0E",
														}}>
														{range.start_date == range.end_date
															? `${formatDate(range.start_date, "YYYY-MM-DD", "Do MMM  YYYY")}`
															: `${formatDate(range.start_date, "YYYY-MM-DD", "Do MMM  YYYY")} - ${formatDate(
																	range.end_date,
																	"YYYY-MM-DD",
																	"Do MMM  YYYY"
															  )}`}
														{/* {"23rd Sept 2021 - 14th Oct 2021"} */}
													</Text>
												</div>
											</div>
										</Row>
										<div
											style={{
												display: "flex",
												marginLeft: "12px",
												flexDirection: "column",
												width: "500px",
												margin: "24px",
											}}>
											<div
												style={{
													fontStyle: "normal",
													fontWeight: "1000",
													fontSize: "20px",
													lineHeight: "32px",
													color: "#005F0E",
													display: "flex",
													width: "50%",
													justifyContent: "space-between",
												}}>
												<span>{sharePointAnalytics.total_points}</span>
												<span style={{ width: "26%" }}>{sharePointAnalytics.total_aed}</span>
											</div>
											<div
												style={{
													fontStyle: "normal",
													fontWeight: "500",
													fontSize: "12px",
													lineHeight: "18px",
													color: "#005F0E",

													width: "50%",
													display: "flex",
													justifyContent: "space-between",
												}}>
												<span>Points Shared</span>

												<span style={{ width: "26%" }}>{`In ${JSON.parse(localStorage.getItem("countryData"))?.currency}`}</span>
											</div>
										</div>
										<Row></Row>
									</Col>
									<Col span={10}>
										<SharePointsLogo
											style={{
												height: "180px",
												width: "400px",
											}}
										/>
									</Col>
								</Row>
							</Row>

							{!loading && (
								<Row
									style={{
										background: "#FFFFFF",
										marginTop: "44px",
										borderRadius: "5px",
										padding: "24px",
									}}>
									<Row>
										<Text
											style={{
												color: "#181818",
												fontStyle: "normal",
												fontWeight: "bold",
												fontSize: "20px",
												lineHeight: "32px",
											}}>
											{"Recent Shared Stats"}
										</Text>
									</Row>
									<BarPlots
										data={sharePointAnalytics.amount_shared_list?.map((item) => {
											return {
												// date: formatDate(item.date, "DD-MM-YYYY", "MMM Do YYYY"),
												date: formatDate(item.date, "DD-MM-YYYY", "DD/MM/YYYY"),
												"Amount shared": item.amount_shared,
											};
										})}
										stacked={false}
										stackFeild={""}
										xaxis={"date"}
										yaxis={"Amount shared"}
										color={"#fec708"}
									/>
								</Row>
							)}
							<Row
								style={{
									background: "#FFFFFF",
									marginTop: "44px",
									borderRadius: "5px",
									padding: "24px",
								}}>
								<Row>
									<Text
										style={{
											color: "#181818",
											fontStyle: "normal",
											fontWeight: "bold",
											fontSize: "20px",
											lineHeight: "32px",
										}}>
										{"Recent Shared Stats"}
									</Text>
								</Row>
								<BarPlots
									title={"Transaction Status Stats"}
									data={sharePointAnalytics.txn_count_list?.map((item) => {
										return {
											...item,
											date: formatDate(item.date, "DD-MM-YYYY", "DD/MM/YYYY"),
										};
									})}
									stacked={true}
									stackFeild={"status"}
									xaxis={"date"}
									yaxis={"count"}
									color={["#C91713", "#FAAD14", "#fec708"]}
								/>
							</Row>
							<Row>
								<RecentTransactions range={range} />
							</Row>
						</div>
						<div
							style={{
								width: "28%",
								marginLeft: "32px",
							}}>
							<Row></Row>
							<Row>
								<div
									style={{
										width: "100%",
										height: "180px ",
										background: "#99EEFF",
										borderRadius: "8px",
										marginTop: "32px",
										display: "flex",
										flexDirection: "column",
									}}>
									<Row>
										<div
											style={{
												marginTop: "16px",
												marginLeft: "24px",
												// display: "flex",
												// flexDirection: "column",
											}}>
											<Text
												style={{
													fontStyle: "normal",
													fontWeight: "600",
													fontSize: "14px",
													lineHeight: "22px",
													color: "#464646",
												}}>
												Lifetime
											</Text>
											<div
												style={{
													marginTop: "4px",
													display: "flex",
													justifyContent: "space-between",
												}}>
												<Text
													style={{
														width: "40%",
														fontStyle: "normal",
														fontWeight: "bold",
														fontSize: "24px",
														lineHeight: "40px",
														color: "#181818",
													}}>
													{sharePointAnalytics.total_lifetime_points}
												</Text>
												<Text
													style={{
														width: "50%",
														fontStyle: "normal",
														fontWeight: "bold",
														fontSize: "24px",
														lineHeight: "40px",
														color: "#181818",
													}}>
													{sharePointAnalytics.total_lifetime_aed}
												</Text>
											</div>
											<div
												style={{
													marginTop: "4px",
													display: "flex",
													justifyContent: "space-between",
												}}>
												<Text
													style={{
														width: "40%",
														fontStyle: "normal",
														fontWeight: "600px",
														fontSize: "12px",
														lineHeight: "18px",
														color: "#464646",
													}}>
													Points Shared
												</Text>
												<Text
													style={{
														width: "49%",
														fontStyle: "normal",
														fontWeight: "600px",
														fontSize: "12px",
														lineHeight: "18px",
														color: "#464646",
													}}>
													{`In ${JSON.parse(localStorage.getItem("countryData"))?.currency}`}
												</Text>
											</div>
										</div>
									</Row>
									<DubaiLogo
										style={{
											width: "100%",
											position: "absolute",
											bottom: "0%",
										}}
									/>
								</div>
							</Row>

							<Row
								style={{
									marginTop: "49px",
									borderRadius: "5px",
									background: "#FFFFFF",
									padding: "12px",
								}}>
								<LeaderBoard leaderboard={sharePointAnalytics.leaderboard_list} />
							</Row>
						</div>
					</Row>
					<Modal
						centered
						visible={settingModal}
						destroyOnClose
						maskClosable={false}
						onCancel={() => setSettingModal(false)}
						footer={null}
						width={600}>
						<Row className="modal-row">
							<Row display={"flex"}>
								<Avatar
									size={35}
									src={CoinLogo}
									style={{
										marginRight: "16px",
									}}
								/>
								<Text
									style={{
										fontWeight: "bold",
										color: "#181818",
										fontSize: "24px",
										position: "absolute",
									}}>
									Set The Daily Transaction Limit
								</Text>
							</Row>
							<Row style={{ marginTop: "40px" }}>
								<Text
									style={{
										fontSize: "14px",
										color: "#181818",
										fontWeight: "bold",

										lineHeight: "22px",
										// fontWeight:"bold"
									}}>
									Minimum Share Points
								</Text>
								<Input
									className="time-value-cohort-col-main-element"
									style={{ width: "100%", marginTop: "8px" }}
									placeholder="Enter minimum share points"
									value={settings.data1}
									onChange={(event) => setSettings({ ...settings, data1: event.target.value })}
								/>
							</Row>
							<Row style={{ marginTop: "40px" }}>
								<Text
									style={{
										fontSize: "14px",
										color: "#181818",
										fontWeight: "bold",

										lineHeight: "22px",
										// fontWeight:"bold"
									}}>
									Maximum Share Points
								</Text>
								<Input
									className="time-value-cohort-col-main-element"
									style={{ width: "100%", marginTop: "8px" }}
									placeholder="Enter maximum share points"
									value={settings.data2}
									onChange={(event) => setSettings({ ...settings, data2: event.target.value })}
								/>
							</Row>
							<Row style={{ marginTop: "40px" }}>
								<Row
									style={{
										display: "flex",
										justifyContent: "end",
									}}>
									<Button
										size="large"
										style={{
											height: "40px",
											boxShadow: "none",
											border: "1px solid #D9D9D9",
											borderRadius: "4px",
											backgroundColor: "#FFFFFF",
											color: "#181818",
										}}
										onClick={() => setSettingModal(false)}>
										Cancel
									</Button>
									<Button
										size="large"
										style={{
											height: "40px",
											width: "67px",
											borderRadius: "4px",
											border: "none",
											background: "#fec708",
											color: "#FFFFFF",
											marginLeft: "16px",
										}}
										onClick={() => {
											setSettingModal(false);
											updateFeatureListApi({
												requestData: {
													countryId: JSON.parse(localStorage.getItem("countryData"))?.database_identifier,
													SHARE_POINTS: {
														config: {
															MINIMUM_AMOUNT: settings.data1,
															MAXIMUM_AMOUNT: settings.data2,
														},
													},
													// REFER_AND_EARN: {
													// 	config: {
													// 		GIVE_REWARD: "boolean",
													// 		REWARD_LEVEL_1: "int",
													// 		REWARD_LEVEL_2: "int",
													// 	},
													// },
												},
												res200Callback: () => {
													message.success("Share points limits updated successfully.");
												},
												resErrorCallback: () => {
													message.error("Error while updating share points limits!");
												},
											});
										}}>
										Save
									</Button>
								</Row>
							</Row>
						</Row>
					</Modal>
				</Row>
			)}
		</>
	);
};

export default SharePointsAnalytics;
